<template>
    <div :style="$vuetify.display.xs ? 'height:350px; overflow-y:auto;' : 'height:auto'" class="pa-2 pa-md-3">
        <v-form v-model="validateform">
            <!-- Header Section -->
            <div class="form-header mb-3 text-center">
                <v-icon :style="{ color: '#2553b9', fontSize: '32px', marginBottom: '8px' }">fa:fa-solid fa-user-edit</v-icon>
                <h3 style="color: #2553b9; font-size: 1.1rem; font-weight: 700; margin-bottom: 4px;">
                    Confirma tus datos personales
                </h3>
                <p style="color: #757575; font-size: 0.8rem;">
                    Verifica que la información sea correcta
                </p>
            </div>

            <!-- Personal Information Section -->
            <div class="info-section mb-3">
                <div class="section-title mb-2">
                    <v-icon :style="{ color: '#2553b9', fontSize: '16px', marginRight: '6px' }">fa:fa-solid fa-id-card</v-icon>
                    <span style="font-size: 0.9rem; font-weight: 700;">Información Personal</span>
                </div>
                
                <v-row>
                    <v-col cols="12" md="6" xl="4">
                        <label class="field-label">
                            <v-icon :style="{ fontSize: '12px', marginRight: '4px' }">fa:fa-solid fa-hashtag</v-icon>
                            DNI
                        </label>
                        <v-text-field 
                            v-model="datauserregister.numero_documento" 
                            variant="outlined" 
                            density="compact" 
                            hide-details="auto"
                            :rules="[rules.required]"
                            class="modern-input">
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" xl="4">
                        <label class="field-label">
                            <v-icon :style="{ fontSize: '12px', marginRight: '4px' }">fa:fa-solid fa-user</v-icon>
                            Apellidos
                        </label>
                        <v-text-field 
                            v-model="datauserregister.apellidos" 
                            variant="outlined" 
                            density="compact" 
                            hide-details="auto"
                            :rules="[rules.required]"
                            class="modern-input">
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" xl="4">
                        <label class="field-label">
                            <v-icon :style="{ fontSize: '12px', marginRight: '4px' }">fa:fa-solid fa-user</v-icon>
                            Nombres
                        </label>
                        <v-text-field 
                            v-model="datauserregister.nombres" 
                            variant="outlined" 
                            density="compact" 
                            hide-details="auto"
                            :rules="[rules.required]"
                            class="modern-input">
                        </v-text-field>
                    </v-col>
                </v-row>
            </div>

            <!-- Student Information Section -->
            <div class="info-section mb-3" v-if="datauserregister.tipouser == 'estudiante'">
                <div class="section-title mb-2">
                    <v-icon :style="{ color: '#2553b9', fontSize: '16px', marginRight: '6px' }">fa:fa-solid fa-graduation-cap</v-icon>
                    <span style="font-size: 0.9rem; font-weight: 700;">Información Académica</span>
                </div>
                
                <v-row>
                    <v-col cols="12" md="8" xl="9">
                        <label class="field-label">
                            <v-icon :style="{ fontSize: '12px', marginRight: '4px' }">fa:fa-solid fa-book</v-icon>
                            Carrera
                        </label>
                        <v-text-field 
                            v-model="datauserregister.carrera" 
                            variant="outlined" 
                            density="compact" 
                            hide-details="auto"
                            :rules="[rules.required]"
                            class="modern-input">
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" md="4" xl="3">
                        <label class="field-label">
                            <v-icon :style="{ fontSize: '12px', marginRight: '4px' }">fa:fa-solid fa-calendar</v-icon>
                            Admisión
                        </label>
                        <v-text-field 
                            v-model="datauserregister.admision" 
                            variant="outlined" 
                            density="compact" 
                            hide-details="auto"
                            :rules="[rules.required]"
                            class="modern-input">
                        </v-text-field>
                    </v-col>
                </v-row>
            </div>

            <!-- Employee Information Section -->
            <div class="info-section mb-3" v-if="datauserregister.tipouser == 'colaborador'">
                <div class="section-title mb-2">
                    <v-icon :style="{ color: '#2553b9', fontSize: '16px', marginRight: '6px' }">fa:fa-solid fa-briefcase</v-icon>
                    <span style="font-size: 0.9rem; font-weight: 700;">Información Laboral</span>
                </div>
                
                <v-row>
                    <v-col cols="12" md="6" xl="7">
                        <label class="field-label">
                            <v-icon :style="{ fontSize: '12px', marginRight: '4px' }">fa:fa-solid fa-user-tie</v-icon>
                            Cargo
                        </label>
                        <v-text-field 
                            v-model="datauserregister.cargo" 
                            variant="outlined" 
                            density="compact" 
                            hide-details="auto"
                            :rules="[rules.required]"
                            class="modern-input">
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" xl="5">
                        <label class="field-label">
                            <v-icon :style="{ fontSize: '12px', marginRight: '4px' }">fa:fa-solid fa-building</v-icon>
                            Área
                        </label>
                        <v-text-field 
                            v-model="datauserregister.area" 
                            variant="outlined" 
                            density="compact" 
                            hide-details="auto"
                            :rules="[rules.required]"
                            class="modern-input">
                        </v-text-field>
                    </v-col>
                </v-row>
            </div>

            <!-- Contact Information Section -->
            <div class="info-section">
                <div class="section-title mb-2">
                    <v-icon :style="{ color: '#2553b9', fontSize: '16px', marginRight: '6px' }">fa:fa-solid fa-address-book</v-icon>
                    <span style="font-size: 0.9rem; font-weight: 700;">Información de Contacto</span>
                </div>
                
                <v-row>
                    <v-col cols="12" md="6">
                        <label class="field-label">
                            <v-icon :style="{ fontSize: '12px', marginRight: '4px' }">fa:fa-solid fa-phone</v-icon>
                            Número de contacto
                        </label>
                        <v-text-field 
                            v-model="datauserregister.celular" 
                            variant="outlined" 
                            density="compact" 
                            hide-details="auto"
                            :rules="[rules.required, rules.celular]"
                            class="modern-input"
                            prepend-inner-icon="fa:fa-solid fa-phone">
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" md="6">
                        <label class="field-label">
                            <v-icon :style="{ fontSize: '12px', marginRight: '4px' }">fa:fa-solid fa-envelope</v-icon>
                            Correo electrónico
                        </label>
                        <v-text-field 
                            v-model="datauserregister.email" 
                            variant="outlined" 
                            density="compact" 
                            hide-details="auto"
                            :rules="[rules.required, rules.email]"
                            class="modern-input"
                            prepend-inner-icon="fa:fa-solid fa-envelope">
                        </v-text-field>
                    </v-col>
                </v-row>
            </div>
        </v-form>
    </div>
</template>



<script>
import Filters from '@/modules/Shared/Filters';
import { mapActions, mapState } from 'vuex';

export default {
    mixins: [Filters],
    data(){
        return{
            validateform: true
        }
    },
    computed:
    {
        ...mapState('login', ['datauserregister'])
    },
    watch:{
        validateform:{
            handler(newval, oldval){
                this.validateform = newval;
                this.$emit('validateFormEvent', this.validateform)
                
            }
        }
    },
    mounted()
    {
        this.$emit('validateFormEvent', this.validateform)
    }
}
</script>

<style scoped>
.form-header {
    animation: fadeIn 0.4s ease-out;
}

.info-section {
    animation: slideInUp 0.4s ease-out;
    background: rgba(37, 83, 185, 0.03);
    border-radius: 10px;
    padding: 0.8rem;
    border-left: 3px solid #2553b9;
}

.section-title {
    display: flex;
    align-items: center;
    color: #2553b9;
    font-weight: 600;
}

.field-label {
    display: flex;
    align-items: center;
    font-size: 0.8rem;
    font-weight: 600;
    color: #424242;
    margin-bottom: 0.3rem;
}

.modern-input :deep(.v-field) {
    border-radius: 8px;
    transition: all 0.2s ease;
}

.modern-input :deep(.v-field:hover) {
    box-shadow: 0 1px 6px rgba(37, 83, 185, 0.1);
}

.modern-input :deep(.v-field--focused) {
    box-shadow: 0 2px 10px rgba(37, 83, 185, 0.15);
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-8px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes slideInUp {
    from {
        opacity: 0;
        transform: translateY(12px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (max-width: 600px) {
    .info-section {
        padding: 0.6rem;
    }
}
</style>